import { render, staticRenderFns } from "./LeftContainer.vue?vue&type=template&id=406af8f4&scoped=true"
import script from "./LeftContainer.vue?vue&type=script&lang=js"
export * from "./LeftContainer.vue?vue&type=script&lang=js"
import style0 from "./LeftContainer.vue?vue&type=style&index=0&id=406af8f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406af8f4",
  null
  
)

export default component.exports